<div class="selected-products-summary" [class.selected-products-summary--invalid]="invalid()">
  @if (singleSelectedProduct(); as product) {
    <div class="selected-products-summary__image">
      @if (product.imageUrl) {
        <img [src]="product.imageUrl" [alt]="product.name" />
      } @else {
        <pdq-icon icon="cube" size="medium" color="var(--on-surface-light)"></pdq-icon>
      }
    </div>
    <div class="selected-products-summary__details">
      <p class="body-14-semibold selected-products-summary__title">{{ product.name }}</p>
      <p class="body-12-regular selected-products-summary__meta">
        {{ product.name }} | SKU: {{ product.sku || 'N/A' }}
        @if (product['variantTitle']) {
          <span> | {{ product['variantTitle'] }}</span>
        }
      </p>
    </div>
  } @else if (selectedProducts().length) {
    <div class="selected-products-summary__details">
      <p class="body-14-semibold selected-products-summary__title">{{ selectedProductsCountLabel() }}</p>
      <p class="body-12-regular selected-products-summary__meta">{{ selectedProductNamesSummary() }}</p>
    </div>
  } @else {
    <div class="selected-products-summary__details">
      <p class="body-12-regular selected-products-summary__meta">{{ emptyMessage() }}</p>
    </div>
  }

  <pdq-button
    [plain]="true"
    variant="ghost-light"
    labelColor="var(--secondary-default)"
    [label]="actionLabel()"
    (onClick)="actionClick.emit()"></pdq-button>
</div>
